import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Functional Endoscopic Sinus Surgery in Delhi, India | Cost & Doctor</title>
            <meta name="description" content="Get expert Functional Endoscopic Sinus Surgery (FESS) in Delhi, India. Affordable endoscopic sinus surgery cost with advanced treatment at MedFirst ENT Centre." />
            <meta name="keywords" content="Functional Endoscopic Sinus Surgery, Functional Endoscopic Sinus Surgery Delhi, Endoscopic Sinus Surgery, Endoscopic Sinus Surgery Delhi, Endoscopic Sinus Surgery Cost in India, FESS Surgery Delhi, Sinus Surgery in Delhi NCR, Endoscopic Sinus Treatment India" />
            <link rel="canonical" href="https://entdelhi.com/functional-endoscopic-sinus-surgery/" />
            <meta property="og:title" content="Functional Endoscopic Sinus Surgery in Delhi, India | Cost & Doctor" />
            <meta property="og:description" content="Get expert Functional Endoscopic Sinus Surgery (FESS) in Delhi, India. Affordable endoscopic sinus surgery cost with advanced treatment at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
